var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showList)?_c('template-list',{attrs:{"type":'inspector',"columnsData":_vm.columnsData}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }